// Every finished game, kept on this device. It works for people who never sign
// in (most of them), so nothing here waits on the leaderboard. The puzzle
// already kept its own list before this; it is read in, not copied, so a
// solve is never counted twice.

const KEY = 'opq-play-history';
const PUZZLE_KEY = 'opq-puzzle-history';
const MAX = 100;

export const GAME_INFO = {
  character: { name: 'Character Quiz', path: '/quiz', icon: '/character-quiz-and-any-related.png', outOf: 15 },
  image: { name: 'Image Quiz', path: '/image-quiz', icon: '/image-quiz-and-any-related.png', outOf: 15 },
  devilfruit: { name: 'Devil Fruit Quiz', path: '/devil-fruit-quiz', icon: '/devil-fruit-quiz-and-any-related.png', outOf: 15 },
  bounty: { name: 'Bounty Battle', path: '/bounty-battle', emoji: '💰', outOf: 11 },
  which: { name: 'Which Character Are You?', path: '/which-character', emoji: '❓' },
  puzzle: { name: 'Jigsaw Puzzle', path: '/puzzle', emoji: '🧩' },
};

const read = (key) => {
  try { return JSON.parse(localStorage.getItem(key)) || []; } catch (e) { return []; }
};

// entry: { gameType, score?, totalTime? (seconds), result?, image? }
export const recordPlay = (entry) => {
  try {
    const list = [{ ...entry, at: Date.now() }, ...read(KEY)].slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch (e) { /* private mode — the game still finishes */ }
};

const slugName = (slug) => slug.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

export const readPlays = () => {
  const puzzles = read(PUZZLE_KEY).map((p) => ({
    gameType: 'puzzle',
    at: p.at,
    totalTime: Math.round(p.ms / 1000),
    result: `${slugName(p.slug)} · ${p.pieces} pieces`,
    image: `/puzzle/thumb/${p.slug}.jpg`,
    record: p.record,
  }));
  return [...read(KEY), ...puzzles].sort((a, b) => b.at - a.at);
};
